import TileSubPanel from "components/TileSubPanel";
import BlockListCard from "./BlockListCard";
import { getBlockList } from "common/utils";
import { useRefData } from "common/hooks";

export default function BlockList({ farm, analysis }) {
    const refData = useRefData();

    const blockList = getBlockList(analysis.blocks);

    const supplementBlocks = blockList.productiveBlocks;
    const nonSupplementBlocks = blockList.nonProductiveBlocks;

    return (
        <div>
            {refData.blockTypes &&
                refData.blockTypes.map((blockType) => {
                    const blocksByType = supplementBlocks.filter((block) => block.type === blockType.value);
                    return (
                        blocksByType.length > 0 && (
                            <TileSubPanel key={blockType.value} title={`${blockType.text} ${blockType.value === "FodderCrop" ? "rotations" : " blocks"}`} stickyHeaderName={`analysis.supplements.${blockType.value}.collapsed`}>
                                {blocksByType.map((block) => (
                                    <BlockListCard key={block.id} farm={farm} analysis={analysis} block={block} />
                                ))}
                            </TileSubPanel>
                        )
                    );
                })}
            {nonSupplementBlocks.length > 0 && (
                <TileSubPanel title="Other blocks" stickyHeaderName="analysis.supplements.otherBlocks.collapsed">
                    {nonSupplementBlocks.map((block) => (
                        <BlockListCard key={block.id} farm={farm} analysis={analysis} block={block} />
                    ))}
                </TileSubPanel>
            )}
        </div>
    )
}
